<div>
    <div class="ui four column stackable grid">
        <div class="ui column"></div>
        <div class="ui column">
            <div class="ui left icon input name" id="name">
                <input type="text" placeholder="Nom" [(ngModel)]="contact.name" (keyup)="onNameChanged()">
                <i class="user icon"></i>
            </div>
            <div class="ui left icon input" id="email">
                <input type="text" placeholder="Adresse mail" [(ngModel)]="contact.email" (keyup)="onEmailChanged()">
                <i class="mail icon"></i>
            </div>
        </div>
        <div class="ui column">
            <textarea placeholder="Votre message"  [(ngModel)]="contact.message" (keyup)="onMessageChanged()"></textarea>
        </div>
        <div class="ui column"></div>
    </div>
    <button class="ui button send-button" (click)="submit()">Envoyer</button>
    <waiting-popup [waitingMessage]="waitingMessage"
                   [successMessage]="successMessage"
                   [errorMessage]="errorMessage">
    </waiting-popup>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/generic/contact/contact.html